import React from "react";

const Page404 = () => {
  return (
    <>
      <div className="flex md:my-16 my-20 flex-col items-center justify-center w-full gap-5   md:mb-0">
        <div className="relative w-[16rem] h-[5rem] my-5">
          <img src="/isologo.png" alt="logo_netmax" fill />
        </div>
        <h3 className="md:text-5xl text-3xl my-5 font-semibold">Error 404#</h3>
        <div className="flex flex-col items-center gap-2 ">
          <h3 className="text-xl text-center md:text-2xl mx-1">
            La página que solicitaste no se pudo encontrar
          </h3>
          <a
            href="/"
            className="font-bold my-5 bg-white text-blue-900 px-2 py-1 rounded-md hover:opacity-50"
          >
            Volver
          </a>
        </div>
      </div>
    </>
  );
};

export default Page404;
